export const isContentPage = (location) => location.pathname !== '/';
